import { DependencyList, useEffect } from "react";

export const pushToDataLayer = (
    eventName: string,
    payload: Record<string, any>
) => {
    pushToGoogleTagManager(eventName, payload);
    pushToMatomo(eventName, payload);
};

export const pushToGoogleTagManager = (
    eventName: string,
    payload: Record<string, any>
) => {
    if (window) {
        (window as any).dataLayer.push({
            event: eventName,
            ...payload,
        });
    } else {
        console.error(
            new Error(
                `analytics: Can't log event "${eventName}" to gtm (no window)`
            )
        );
    }
};

export type MatomoEvent = { event: string; [k: string]: any };
declare global {
    interface Window {
        _mtm: MatomoEvent[];
    }
}
if (typeof window !== "undefined") {
    window._mtm ??= [];
}
export const pushToMatomo = (
    eventName: MatomoEvent["event"],
    payload: Omit<MatomoEvent, "event">
) => {
    if (window) {
        window._mtm.push({
            event: eventName,
            ...payload,
        });
    } else {
        console.error(
            new Error(
                `analytics: Can't log event "${eventName}" to mtm (no window)`
            )
        );
    }
};

const pushToAnalytics = pushToDataLayer;

export const usePushToDataLayer = (
    ...[eventName, payload, dependencies]:
        | Parameters<typeof pushToDataLayer>
        | [...Parameters<typeof pushToDataLayer>, DependencyList]
) =>
    useEffect(
        () => pushToDataLayer(eventName, payload),
        [eventName, payload, ...(dependencies ?? [])]
    );

export default pushToAnalytics;
